/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 删除我的观演人
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  id: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "delete",
    url: `/member/view/${id}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
